import numOrDefault from 'lib/helpers/numOrDefault';
import { formatDate, mString } from 'lib/helpers/utility';

import {
  APPOINTMENT_RESOURCE_OPTIONS,
  PATIENT_OPTIONS,
  PROVIDER_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

import isEstimated from '../lib/isEstimated';

import Actions from './components/Actions';
import NavigateToClaimCell from './components/NavigateToClaimCell';
import NavigateToERACell from './components/NavigateToERACell';

export const EstCell = (params) => {
  if (params?.node?.group) {
    let estimated = false;

    params.node.allLeafChildren.forEach((child) => {
      const procedures = child?.data?.procedures || [];
      estimated = isEstimated({ procedures });
    });

    const value = params?.valueFormatted ?? 0;

    return estimated && value > 0 ? `${value} estimated` : value;
  }

  const procedures = params?.data?.procedures || [];
  const estimated = isEstimated({ procedures });

  const value = params?.valueFormatted ?? 0;

  return estimated && value > 0 ? `${value} estimated` : value;
};

export const getColDefs = (timezone, claims) => [
  {
    field: 'dateofservice',
    headerName: 'Date of Service',
    valueGetter: (params) => {
      if (!!params?.node?.group) {
        return '';
      }
      const dos = params?.data?.dateofservice;
      return formatDate(dos, timezone, true);
    }
  },
  {
    field: 'patient_name',
    headerName: 'Patient',
    pinned: 'left'
  },
  {
    field: 'provider',
    headerName: 'Provider'
  },
  {
    field: 'charge',
    headerName: 'Charge',
    valueFormatter: ({ value }) => mString(numOrDefault(value)),
    aggFunc: 'sum',
    sortable: false
  },
  {
    field: 'ins_payment',
    headerName: 'Ins. Payment',
    valueFormatter: ({ value }) => mString(value),
    aggFunc: 'sum',
    sortable: false,
    hide: !!claims
  },
  {
    field: 'ins_adjustment',
    headerName: 'Ins. Adj',
    valueFormatter: ({ value }) => mString(value),
    cellRenderer: EstCell,
    aggFunc: 'sum',
    sortable: false,
    hide: !!claims
  },
  {
    field: 'other_adj',
    headerName: 'Other Adj',
    valueFormatter: ({ value }) => mString(value),
    aggFunc: 'sum',
    sortable: false
  },
  {
    field: 'pt_payment',
    headerName: 'Pt. Payment',
    valueFormatter: ({ value }) => mString(numOrDefault(value)),
    aggFunc: 'sum',
    sortable: false
  },
  {
    field: 'ins_balance',
    headerName: 'Ins. Balance',
    valueFormatter: ({ value }) => mString(numOrDefault(value)),
    cellRenderer: EstCell,
    aggFunc: 'sum',
    sortable: false,
    hide: !!claims
  },
  {
    field: 'pt_balance',
    headerName: 'Pt. Balance',
    valueFormatter: ({ value }) => mString(value),
    cellRenderer: EstCell,
    aggFunc: 'sum',
    sortable: false
  },

  {
    field: 'claimsIds',
    headerName: 'Claim ID',
    cellRenderer: NavigateToClaimCell,
    sortable: false
  },
  {
    field: 'era_eob',
    sortable: false,
    headerName: 'ERA/EOB',
    cellRenderer: NavigateToERACell
  },
  {
    field: 'total_balance',
    headerName: 'Total Balance',
    aggFunc: 'sum',
    pinned: 'right',
    valueFormatter: ({ value }) => mString(value),
    sortable: false
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: Actions,
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const DEFAULT_COLUMN_DEFS = {
  enableRowGroup: true
};

export const GRID_OPTIONS = {
  animateRows: true,
  rowGroupPanelShow: 'always',
  enableRangeSelection: true,
  showOpenedGroup: true,
  suppressAggFuncInHeader: true,
  autoGroupColumnDef: {
    pinned: 'left',
    sortable: false
  }
};

export const DEFAULT_FILTERS = {
  date: {
    type: 'date-range',
    title: 'Date of Invoice',
    icon: 'calendar-mono'
  },
  patient: PATIENT_OPTIONS,
  provider: PROVIDER_OPTIONS,
  appointment_resource: APPOINTMENT_RESOURCE_OPTIONS
};

export const getFinalColDefs = (name, claims, timezone) => {
  let colDefs = [...getColDefs(timezone, claims)];
  if (name === 'patient_ledger') {
    colDefs[1] = {
      field: 'patient_name',
      headerName: 'Patient',
      rowGroup: true,
      hide: true,
      pinned: 'left'
    };
  }

  if (name === 'ledger') {
    colDefs = colDefs.filter((col) => col.field !== 'patient_name');
  }
  return colDefs;
};

export const getPatientDefaultFilters = () => {
  const newDefaultFilters = { ...DEFAULT_FILTERS };
  delete newDefaultFilters.patient;

  return newDefaultFilters;
};
